import { 
  CREATE_BRANDKIT_BUTTON, DELETE_BRANDKIT_BUTTON, UPDATE_BRANDKIT_BUTTON_PROPERTY, 
  RENAME_BRANDKIT_BUTTON, UPDATE_BRANDKIT_BUTTON_CONTENT, ASSOCIATE_FONTS_WITH_BRANDKIT_BUTTON,
  FETCHING_BRANDKIT_BUTTONS_REQUEST, FETCHING_BRANDKIT_BUTTONS_SUCCEEDED, FETCHING_BRANDKIT_BUTTONS_FAILED,
  DELETE_BRANDKIT_BUTTONS_REQUEST, DELETING_BRANDKIT_BUTTONS_SUCCEEDED, DELETING_BRANDKIT_BUTTONS_FAILED,
  UPDATE_BRANDKIT_BUTTONS_REQUEST, UPDATING_BRANDKIT_BUTTONS_SUCCEEDED, UPDATING_BRANDKIT_BUTTONS_FAILED,
  INVALIDATE_BRANDKIT_BUTTON,
} from 'constants/actionTypes';
  
  import { call, put, takeEvery } from 'redux-saga/effects';
  import axios from 'axios';
  import { createAction } from 'redux-actions';
  import buildUrl from 'build-url';
  
  const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
  const BRANDKIT_BUTTONS_URL = `${apiUrl}/api/2.0/palette`;

  export const createBrandkitButton = createAction(CREATE_BRANDKIT_BUTTON, (component) => {
    return {
      component: component
    };
  });

  export const deleteBrandkitNewButtons = createAction(DELETE_BRANDKIT_BUTTON, (ids) => {
    return {
      ids: ids
    };
  });

  export const updateBrandkitButtonProperty = createAction(UPDATE_BRANDKIT_BUTTON_PROPERTY, (id, widget_uid, property) => {
    return {
      id: id,
      widget_uid: widget_uid,
      property: property
    };
  });

  export const updateBrandkitButtonContent = createAction(UPDATE_BRANDKIT_BUTTON_CONTENT, (id, widget_uid, content) => {
    return {
      id: id,
      widget_uid: widget_uid,
      content: content
    };
  });

  export const renameBrandkitButton = createAction(RENAME_BRANDKIT_BUTTON, (id, widget_uid, name) => {
    return {
      id: id,
      widget_uid: widget_uid,
      name: name
    };
  });

  export const associateFontWithBrandkitButton = createAction(ASSOCIATE_FONTS_WITH_BRANDKIT_BUTTON, (id, widget_uid, fonts) => {
    return {
      id: id,
      widget_uid: widget_uid,
      fonts: fonts
    };
  });
  
  /**
   * Fetch Brankit Buttons
  */
    export const fetchBrandkitButtons = createAction(FETCHING_BRANDKIT_BUTTONS_REQUEST, id => {
      return id;
    })
    
    const fetchBrandkitButtonsSucceeded = createAction(FETCHING_BRANDKIT_BUTTONS_SUCCEEDED, response => {
      return response;
    })
    
    const fetchingBrandkitButtonsFailed = createAction(FETCHING_BRANDKIT_BUTTONS_FAILED, (id, error) => {
      return {
        id: id,
        error: error
      }
    })
    
    function* fetchingBrandkitButtonsSaga(action) {
      const id = action.payload;
    
      let url = buildUrl(BRANDKIT_BUTTONS_URL, {
        path: id
      });
    
      const fetchingBrandkitButtonsAPI = () => {
        return axios.get(url).then(response => response.data);
      }
    
      try {
        const response = yield call(fetchingBrandkitButtonsAPI);
        yield put(fetchBrandkitButtonsSucceeded(response));
      } catch (error) {
        yield put(fetchingBrandkitButtonsFailed(id, error));
      }
    }
  
  
  /**
   * Update Brankit colors
  */
    export const updateBrandkitButtons = createAction(UPDATE_BRANDKIT_BUTTONS_REQUEST, (id, request) => {
      return {
        id: id,
        request: request
      }
    })
    
    export const updateBrandkitButtonsSucceeded = createAction(UPDATING_BRANDKIT_BUTTONS_SUCCEEDED, (response) => {
      return {
        response: response
      }
    })
    
    export const updateBrandkitButtonsFailed = createAction(UPDATING_BRANDKIT_BUTTONS_FAILED, (id, error) => {
      return {
        id: id,
        error: error
      }
    })
    
    function* updateBrandkitButtonsSaga(action) {
      const { id, request } = action.payload;
          
      let url = buildUrl(BRANDKIT_BUTTONS_URL, {
        path: `/${id}`
      });
    
      const updateBrandkitButtonsAPI = () => {
        return axios.put(url, {components: request}).then(response => response.data);
      }

      try {
        const response = yield call(updateBrandkitButtonsAPI);
        if (response) {
          yield put(updateBrandkitButtonsSucceeded(response));
        }
      } catch (error) {
        yield put(updateBrandkitButtonsFailed(error));
      }
    }
  
  
  /**
   * Delete Brandkit colors
  */
    export const deleteBrandkitButtons = createAction(DELETE_BRANDKIT_BUTTONS_REQUEST, (ids, paletteId) => {
      return {
        ids: ids,
        paletteId: paletteId
      }
    }) 
    
    const deleteBrandkitButtonsSucceeded = createAction(DELETING_BRANDKIT_BUTTONS_SUCCEEDED, (ids, response) => {
      return {
        ids: ids,
        response: response
      }
    })
    
    const deleteBrandkitButtonsFailed = createAction(DELETING_BRANDKIT_BUTTONS_FAILED, (ids, error) => {
      return {
        ids: ids,
        error: error
      }
    })
    
    function* deleteBrandkitButtonsSaga(action) {
      const {ids, paletteId} = action.payload;
    
      let url = buildUrl(BRANDKIT_BUTTONS_URL, {
        path: `${paletteId}/component`
      });
    
      const deleteBrandkitButtonsAPI = () => {
        return axios.delete(url, {data: ids}).then(response => response.data);
      }
    
      try {
        const response = yield call(deleteBrandkitButtonsAPI);
        yield put(deleteBrandkitButtonsSucceeded(ids, response));
      } catch (error) {
        yield put(deleteBrandkitButtonsFailed(ids, error));
      }
    }


    export const invalidateBrandkitButton = createAction(INVALIDATE_BRANDKIT_BUTTON);

  
  
  
  export default function* brandkitButtonsSaga() {
    yield takeEvery(FETCHING_BRANDKIT_BUTTONS_REQUEST, fetchingBrandkitButtonsSaga);
    yield takeEvery(DELETE_BRANDKIT_BUTTONS_REQUEST, deleteBrandkitButtonsSaga);
    yield takeEvery(UPDATE_BRANDKIT_BUTTONS_REQUEST, updateBrandkitButtonsSaga);
  }